import type { $Fetch } from 'ofetch';
import type { SectorGateway, ListSectorsParams } from '@/application/port/out/SectorGateway';
import type { Sector, UpsertSectorCommand } from '@/domain/model/Sector';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/sectors';

/** HTTP gateway do CRUD de Sector. Authority BE: `org:sector:read|manage`. */
export class HttpSectorGateway implements SectorGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListSectorsParams): Promise<Page<Sector>> {
    const res = await this.client<ApiResponse<Page<Sector>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<Sector> {
    const res = await this.client<ApiResponse<Sector>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertSectorCommand): Promise<Sector> {
    const res = await this.client<ApiResponse<Sector>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertSectorCommand): Promise<Sector> {
    const res = await this.client<ApiResponse<Sector>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<Sector> {
    // BE retorna 200 + a entidade desativada (não 204) — usa o envelope.
    const res = await this.client<ApiResponse<Sector>>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
    assertApiSuccess(res);
    return res.data;
  }
}
